import { Date } from "core-js";

export {
  formatter_money,
  formatter_date,
  getNowDateTime,
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
  formatter_datetime,
  formatter_money2,
  formatterPeriodDate,
  formatterRate
}

/**
 * 
 * @param {*} val 数值
 * @param {*} prefix 前缀单位
 * @param {*} suffix 后缀单位
 * @returns 
 */
const formatter_money = (val, prefix, suffix) => {
  const numeral = require("numeral");
  prefix = prefix || "$"
  suffix = suffix || ""
  return `${prefix + numeral(val).format("0,0.00") + suffix}`;
}

/**
 * 转换金钱格式: 如果有小数位显示小数位
 * @param {*} val 数值
 * @param {*} prefix 前缀单位
 * @param {*} suffix 后缀单位
 * @returns 
 */
const formatter_money2 = (val, prefix, suffix) => {
  const float = parseFloat(val) - parseInt(val)
  const IsFloat = float > 0

  const format = IsFloat ? "0,0.00" : "0,0"
  const formatPrefix = prefix === undefined ? "$" : prefix
  const formatSuffix = suffix === undefined ? "" : suffix

  const numeral = require("numeral");
  return `${val < 0 ? "-" : ""}${formatPrefix + numeral(val).format(format) + formatSuffix}`;
}


/**
 *
 * @param {*} val 日期
 * @param {string} format  转换格式: yyyy-MM-dd
 */
const formatter_date = (val, format) => {
  if (val === undefined || (val ?? "") === "") {
    return ""
  }
  var date = val

  if (typeof (val) === "string") {
    date = new Date(val);
  }

  var dateStr = format
  if (dateStr === undefined) {
    dateStr = "DD/MM/YYYY"
  }
  dateStr = dateStr.replace("YYYY", formatzero(date.getFullYear(), 4))
  dateStr = dateStr.replace("MM", formatzero(date.getMonth() + 1))
  dateStr = dateStr.replace("DD", formatzero(date.getDate()))

  return dateStr
}
/**
 *
 * @param {*} val 日期时间
 * @param {string} format  转换格式: yyyy-MM-dd
 */
const formatter_datetime = (val, format) => {
  if (val === undefined || (val ?? "") === "") {
    return ""
  }
  var date = val

  if (typeof (val) === "string") {
    date = new Date(val);
  }
  if (!format) {
    format = "DD/MM/YYYY HH:mm:ss"
  }
  var dateStr = format
  dateStr = dateStr.replace("YYYY", date.getFullYear())
  dateStr = dateStr.replace("MM", formatzero(date.getMonth() + 1))
  dateStr = dateStr.replace("DD", formatzero(date.getDate()))

  dateStr = dateStr.replace("HH", formatzero(date.getHours()))
  dateStr = dateStr.replace("mm", formatzero(date.getMinutes()))
  dateStr = dateStr.replace("ss", formatzero(date.getSeconds()))
  dateStr = dateStr.replace("ms", formatzero(date.getMilliseconds()))


  return dateStr
}
/**
 * element-plus formatter method 格式化日期区间
 * @param {*} row 
 * @param {*} column 
 * @param {*} cellValue 
 */
const formatterPeriodDate = (row, column, cellValue) => {

  const startDate = (cellValue || null) === null || cellValue.length === 0 ? new Date() : cellValue[0]
  const endDate = (cellValue || null) === null || cellValue.length < 2 ? new Date() : cellValue[1]
  const startStr = formatter_date(startDate)
  const endStr = formatter_date(endDate)

  return `${startStr} - ${endStr}`
}
/**
 * element-plus formatter method 格式化金额
 * @param {*} row 
 * @param {*} column 
 * @param {*} cellValue 
 * @returns 
 */
const formatterCellMoney = (row, column, cellValue) => {

  const res = formatter_money(cellValue, "$", "")
  return res
}

const getNowDateTime = () => {
  const timestamp = new Date().getTime()

  var date = new Date(parseInt(timestamp, 10));
  var Y = formatzero(date.getFullYear())
  var M = formatzero(date.getMonth());
  var D = formatzero(date.getDate())
  var hh = formatzero(date.getHours())
  var mm = formatzero(date.getMinutes())
  var ss = formatzero(date.getSeconds())
  var ms = formatzero(date.getMilliseconds())
  return `${Y}-${M}-${D} ${hh}:${mm}:${ss}.${ms}`;
}


/**
 * 向前补0
 * @param {*} val 
 * @returns 
 */
const formatzero = (val, length) => {
  if (length === undefined) {
    length = 2
  }
  if (val.toString().length > length) {
    return val
  } else {
    return (Array(length).join(0) + val).slice(0 - length)
  }
}
/**
 * element-plus formatter method 格式化日期
 * @param {*} row 
 * @param {*} column 
 * @param {*} cellValue 
 * @returns 
 */
const formatterCellDate = (row, column, cellValue) => {
  return formatter_date(cellValue, "DD/MM/YYYY")
}
const formatterCellDateTime = (row, column, cellValue) => {
  return formatter_datetime(cellValue, "DD/MM/YYYY HH:mm:ss")
}
/**
 * 月份/周描述
 * @param {*} rate_type 类型 
 * @returns 
 */
const formatterRate = (rate_type) => {
  var text = '';
  switch (rate_type) {
    case 'Week':
      text = 'Weekly';
      break;
    case 'Month':
      text = 'Monthly';
      break;
    case "Year":
      text = 'Yearly';
      break;
  }
  return text;
}
